export const navigateFrameTo = (url: string): void => {
  window.location.assign(url);
};
